const state = reactive({
  get_all: [],
  loading: false,
  page: 1,
  perPage: 12,
  total: null,
})

export function useArticles() {
  const storyblokApi = useStoryblokApi()
  const { locale } = useI18n()

  async function fetchAll(event) {
    state.loading = true
    try {
      const params = {
        version: 'published',
        per_page: state.perPage,
        page: state.page,
        language: locale.value,
        starts_with: 'news/',
        is_startpage: false,
        sort_by: 'content.date:desc',
      }

      const { data } = await storyblokApi.get('cdn/stories', params)

      if (data)
        state.get_all = data.stories

      // state.total = firstResponse.total ? Math.ceil(firstResponse.total / state.perPage) : 1
      // console.log(firstResponse)

      // const otherStories = []
      // for (let currentPage = 2; currentPage <= lastPage; currentPage++) {
      //   params.page = currentPage
      //   otherStories.push((await storyblokApi.get('cdn/stories', params)).data.stories)
      // }

      // const allStories = [firstResponse.data.stories, ...otherStories].flat()
      // console.log(allStories)
      // console.log(allStories.length)
      // console.log(state.perPage)
      // console.log(firstResponse.total)

      // if (firstResponse)
      //   state.get_all = allStories
    }
    catch (error) {
      return sendError(event, createError({
        statusCode: 404,
        statusMessage: 'Unauthorized client error',
      }))
    }
    finally {
      state.loading = false
    }
  }

  return {
    ...toRefs(state),
    fetchAll,
  }
}
